export default "__VITE_ASSET__9MRmX9Cf__"